export function isInt(n) {
  return n % 1 === 0;
}

export function getCurrency(amt) {
  let amount = amt || 0;
  if (isInt(amount)) {
    return `${amount.toLocaleString()}.00`;
  } else {
    return `${parseFloat(amount.toFixed(2)).toLocaleString()}`;
  }
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function isEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function extractDifference(obj1, obj2) {
  let finalObj = {};
  for (let key in obj2) {
    if (obj2[key] !== obj1[key]) {
      finalObj[key] = obj2[key];
    }
  }
  return finalObj;
}
